import localStorage from "local-storage";
import React, { useEffect } from 'react';
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { logout } from '../../actions/index';
import { LOGIN_PAGE } from "../lib/basic";
import axios from "axios";
import { BASE_URL ,HEADER_OPTIONS_AUTH} from "../lib/basic";

//import { SystemManagerUI } from '../admin/ManagerContainer/SystemManager'
export const NavBar = () => {

  const user = useSelector(state => state.authenticated);
  const dispatch = useDispatch();
  // const history = useHistory();
  let viewQbAdminMenu=user.role=='superAdmin'||user.role=="invoicemanager"?true:false

  useEffect(() => {

    if (user && window.location.href !== `${LOGIN_PAGE}`) {
      if (user.role === "admin" || user.role === "superAdmin") {
        if (!localStorage.get("timer")) {
          localStorage.set("timer", 0);
        }
        setInterval(async () => {
          if (localStorage.get("timer") === 3000) {
            await logout(user, dispatch);
            window.location.replace(LOGIN_PAGE);
          }
          localStorage.set("timer", localStorage.get("timer") + 1);
        }, 1000);
      }
    }
  }, []);

  const connectwithquickbooks=async()=>{
    const response = await axios.get(`${BASE_URL}/quickBookAuthorizationUrl`,HEADER_OPTIONS_AUTH(user.token));
    if(response.status === 200){
      const quickBookAuthUrl = response.data.data;
      //check logined status in quick book
      window.location.replace(quickBookAuthUrl)  
      localStorage.set('qbConnectVisible','1')  
      
  }
        
  }


  const quickbooksSignIn=async()=>{
    const aurthorizedURLcode = window.location.href
        console.log(aurthorizedURLcode)  
        localStorage.set('quickbooksAuthCode',aurthorizedURLcode)
      
    console.log("inside signin")
    let splitedList1 = localStorage.get('quickbooksAuthCode').split("&");
    let code = splitedList1[0].split("=")[1];
    let state = splitedList1[1].split("=")[1];
    let realmId = splitedList1[2].split("=")[1];
    console.log(code+" "+state +" "+realmId)
   const res= await axios.get(`${BASE_URL}/quickBookToken/${code}/${state}/${realmId}`,HEADER_OPTIONS_AUTH(user.token))
   console.log(res.data)
   if(res.status==200)
   {
    // localStorage.setItem('quickbooksCredentials',res.data.data)
    localStorage.set("Token", res.data.data);
    localStorage.set('qbConnectVisible','2')
    window.location.reload()
   }
   console.log(localStorage.getItem('quickbooksCredentials'))
  
  }

  const logOut = async () => {
    await logout(user, dispatch);
    localStorage.clear()
    window.location.replace(LOGIN_PAGE);
  }

  return (
    user ? <Navbar
      id="navbar"
      collapseOnSelect
      expand="lg"
      variant="dark"
      style={{ backgroundColor: "#001529" }}
    >
      <Navbar.Brand>
        <img
          alt=""
          src={process.env.PUBLIC_URL + "/img/logo.png"}
          style={{ height: "40px" }}
          className="d-inline-block align-top"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mr-auto">
          {user.role!="invoicemanager"?
          <Nav.Link style={{ fontSize: "18px" }} href="/home">
            Home
        </Nav.Link>:null
}
          {/*<Nav.Link href="#features">Features</Nav.Link>*/}
          {user.role === "superAdmin" || user.role === "admin" || user.role === "businessRep" ? 
            (<NavDropdown
              style={{ fontSize: "18px" }}
              title="TASK"
              id="collasible-nav-dropdown"
            >
              {   /* <NavDropdown.Item href="/task-shipment">
            SHIPMENT
          </NavDropdown.Item>*/}
             
              <NavDropdown.Item href="/task-manage-shipment">
                MANAGE SHIPMENT
          </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="/task-skid">SKID</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="/task-item">ITEM</NavDropdown.Item>

            </NavDropdown>
            ) : (
              <div></div>
            )}
          {(user.role === "operator" || user.role === "admin" || user.role === "superAdmin" || user.role === "businessRep") && (
            <Nav.Link style={{ fontSize: "18px" }} onClick={() => {
              window.open('/daily-target', '_blank');
            }}>
              Daily Target
            </Nav.Link>
          )}
          {user.role === "admin" || user.role === "superAdmin" || user.role === "businessRep"  || user.role==="invoicemanager" ?
            (<NavDropdown
              style={{ fontSize: "18px" }}
              title={ user.role ==="invoicemanager" ? "Invoice": "Admin"}
              id="admin-collasible-nav-dropdown"
            >
              {user.role === "admin" || user.role === "superAdmin" || user.role === "businessRep" ? (
                <div>
                  <NavDropdown.Item href="/admin-client">
                    Manage Client
                  </NavDropdown.Item>

                  <NavDropdown.Divider />
                </div>
              ) : (<div></div>)}
              { user.role === "superAdmin" ? (
                <div>
                  <NavDropdown.Item href="/admin-business-rep">
                    Manage Business Rep.
            </NavDropdown.Item>
                  <NavDropdown.Divider />
                </div>) : (<div></div>)}
              {user.role === "admin" || user.role === "superAdmin" ? (
                <div>
                  <NavDropdown.Item href="/admin-user">
                    Manage User
            </NavDropdown.Item>
                  <NavDropdown.Divider />
                </div>) : (<div></div>)}

              {user.role === "superAdmin" || user.role==="admin"? (
                <div>
                  <NavDropdown.Item href="/manage-kpi">
                    Manage KPI
            </NavDropdown.Item>
                  <NavDropdown.Divider />
                </div>
              ) : (<div></div>)}
              {user.role=="invoicemanager" || user.role === "superAdmin" || user.role==="admin"?
              <NavDropdown.Item href="/manager">Manager</NavDropdown.Item>:null
}
            </NavDropdown>) : (
              <div></div>
            )
          }
         
            { viewQbAdminMenu&&(localStorage.get('qbConnectVisible')==null ||(localStorage.get('qbConnectVisible')=='1' && window.location.href.split('?').length!=2 ) )?
  <Nav.Link style={{ fontSize: "18px" }} onClick={()=>{connectwithquickbooks()}}>
  QB Connect
   
 </Nav.Link>:null
            }
            {viewQbAdminMenu&&(localStorage.get('qbConnectVisible')=='1')?
  <Nav.Link style={{ fontSize: "18px" }} onClick={()=>{quickbooksSignIn()}}>
  Authorize QB
   
 </Nav.Link>:null
            }
   {viewQbAdminMenu &&( localStorage.get('qbConnectVisible')=='2')?
  <Nav.Link style={{ fontSize: "18px" }} onClick={()=>{quickbooksSignIn()}}>
 QB Connected
   
 </Nav.Link>:null
            }
        </Nav>
        <Nav>
          <Nav.Link>
          <i>Release Date: 01-August-2025</i>
          </Nav.Link>
          <Nav.Link style={{ display:"flex",alignItems:"center",gap:"5px" }}>
            <i>Version 2.13.4</i>
           
        </Nav.Link>
          <Nav.Link href="/me" style={{ color: "white" }}>
            Hi, {user.userName}
          </Nav.Link>
          <Nav.Link
            eventKey={2}
            onSelect={async () => logOut()}
          >
            Log out
        </Nav.Link>
        
        </Nav>
      </Navbar.Collapse>
    </Navbar> : <div></div>
  )
}
